/**
 * Chips de filtro rápido (single-select) — padrão de segmented chips.
 * Com `shortLabel`, o chip mostra o texto curto e expõe o nome completo em title/aria-label.
 */
export const Chip = ({ selected, onClick, children, title, ariaLabel }) => (
    <button
        type="button"
        title={title}
        aria-label={ariaLabel}
        aria-pressed={selected}
        onClick={onClick}
        className={`whitespace-nowrap rounded-full border px-2 py-0.5 text-xs transition ${
            selected
                ? "border-primary bg-primary font-semibold text-black"
                : "border-primary/40 bg-mgs-surface text-laranjinha/80 hover:border-primary hover:text-laranjinha"
        }`}
    >
        {children}
    </button>
);

const formatCount = (count) => count.toLocaleString("pt-BR");

const FilterChips = ({ options, selectedKey, onSelect, ariaLabel, className = "" }) => (
    <div aria-label={ariaLabel} className={`flex flex-wrap items-center gap-1 ${className}`} role="group">
        {options.map((option) => {
            const hasCount = typeof option.count === "number";
            const short = option.shortLabel && option.shortLabel !== option.label;
            return (
                <Chip
                    key={option.key}
                    selected={option.key === selectedKey}
                    onClick={() => onSelect(option)}
                    title={short ? option.label : undefined}
                    ariaLabel={short ? `${option.label}${hasCount ? ` (${formatCount(option.count)})` : ""}` : undefined}
                >
                    {option.shortLabel ?? option.label}
                    {hasCount ? <span className="ml-1 opacity-70">{formatCount(option.count)}</span> : null}
                </Chip>
            );
        })}
    </div>
);

export default FilterChips;
